<template>
    <div class="content">
      <div class="col" v-html="content"></div>
    </div>
</template>

<script>
export default {
  name: 'PageCol2',

  data: function () {
    return {
    }
  },

  props: {
    content: {
      type: String,
      required: false,
      default: 'Col1 goes here'
    }
  }
}
</script>

<style scoped>
.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.call-to-action-btn {
  font-size: 13px;
  background-color:rgba(206, 94, 49, 0.5);
  color: #fff;
  border-radius: 20px;
  width: auto;
}

ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

li {
  color: #000;
  font-size: 13px;
  display: table-row;
}

li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

.content {
  column-count: 1;
  padding: 20px;
}

.content .col {
  padding-bottom: 20px;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content {
    column-count: 2;
    padding: 20px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content {
    column-count: 2;
    padding: 20px;
    padding-left: 33%;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content {
    column-count: 2;
    padding: 20px;
    padding-left: 33%;
  }
}
</style>
